import { scaffoldSelector } from "@/components/app/scaffoldReducer";
import SubSubNav from "@/containers/SubSubNav";
import { useAppSelector } from "@/hooks";

import ShortcutsArea from "./ShortcutsArea";

export default function ScaffoldHeader() {
  const { shortcuts, subSubNav } = useAppSelector(scaffoldSelector);

  const hasShortcuts = shortcuts.length > 0;
  const hasNav = subSubNav.length > 0;

  if (!hasNav && !hasShortcuts) return null;

  return (
    <div className="TT-scaffold-header">
      <div className="TT-scaffold-header-nav">
        <SubSubNav />
      </div>

      {hasShortcuts && (
        <div className="TT-scaffold-header-actions">
          <ShortcutsArea shortcuts={shortcuts} />
        </div>
      )}
    </div>
  );
}
